module.exports = __webpack_public_path__ + "img/30f.fc06582a.png";